module.exports = __webpack_public_path__ + "img/taskSquareBlue.94bec15.svg";